import { useState } from "react";
import RolesSCP from "../../../../../../../Services/Data/SCP/RolesSCP";
import TeamsSCP from "../../../../../../../Services/Data/SCP/TeamsSCP";
import './RoleManagement.css';
import RoleButton from "./Components/RoleButton";
import CheckBox from "../../../../../../../Components/CheckBox/CheckBox";
import { AddToastNotification } from "../../../../../../../Services/ToastNotification/ToastNotificationManager";
import ServerRequests from "../../../../../../../Services/Api/ServersRequests.ts";

const RoleManagement = ({serverId, getPlayerIds}) => 
{
    const serverRequests = new ServerRequests();

    const [selectedRole, setSelectedRole] = useState(RolesSCP[0]);
    const [useSpawpoint, setUseSpawpoint] = useState(false);
    const [resetInventory, setResetInventory] = useState(false);

    const setClass = () => {
        const playerIds = getPlayerIds();

        if (playerIds.length > 0)
        {
            let options = (useSpawpoint ? 2 : 0) + (resetInventory ? 1 : 0);
            const command = `/forceclass ${playerIds} ${selectedRole.id} ${options}`;

            serverRequests.ExecuteCommand(serverId, command, () => { AddToastNotification("Polecenie wysłane do wykonania!", 1) })
        }
        else
        {
            AddToastNotification("Musisz wybrać graczy!", 0)
        }
    }

    const grantLoadout = () => {
        const playerIds = getPlayerIds();

        if (playerIds.length > 0)
        {
            const command = `/giveloadout ${playerIds} ${selectedRole.id}`;

            serverRequests.ExecuteCommand(serverId, command, () => { AddToastNotification("Polecenie wysłane do wykonania!", 1) })
        }
        else
        {
            AddToastNotification("Musisz wybrać graczy!", 0)
        }
    }

    return (
        <>
            <h3 className="text-center">Select player(s) and then assign the role.</h3>
            <div className="flex">
                {
                    TeamsSCP.filter(team => !team.hide).map(team => 
                        <div className="teamContainer">
                            <h3>{team.name}</h3>
                            { RolesSCP.filter(role => role.team == team.id).map(role => 
                                <RoleButton role={role} setSelectedRole={setSelectedRole} selectedRole={selectedRole}/>
                            )}
                        </div>
                    )
                }
            </div>
            <div className="m-4 mt-8 flex">
                <div className="w-[50%] text-center" onClick={() => setClass()}>
                    <h3>Target role:</h3>
                    <h2 style={{color: selectedRole.color}}>{selectedRole.name}</h2>
                    <div className="remoteAdminButton w-[50%] m-auto">
                        Set Class
                    </div>
                </div>
                <div className="w-[50%] text-center">
                    <div className="remoteAdminButton w-[50%] m-auto" onClick={() => grantLoadout()}>
                        Grant Loadout
                    </div>
                    <div className="mt-6">
                        <CheckBox value={useSpawpoint} onChange={() => setUseSpawpoint(!useSpawpoint)} text={"Use Spawnpoint"}/>
                        <CheckBox value={resetInventory} onChange={() => setResetInventory(!resetInventory)} text={"Reset Inventory"}/>
                    </div>
                </div>
            </div>
        </>
    )
} 
export default RoleManagement;